import * as React from 'react';

import { TextField, InputLabel, Grid, Box, FormControl, Button, MenuItem, Select } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

type SensorParameter = {
  id: string,
  name: string,
  side: string,
  pos: string
};
export const SensorParametersState = 
  atom<SensorParameter[]>({
    key: 'SensorParameters',
    default: [
      {id:'0001', name: 'PORT1', side: 'PRT', pos: 'POS1'},
      {id:'0002', name: 'STB1', side: 'STB', pos: 'POS1'},
      {id:'0003', name: 'PORT2', side: 'PRT', pos: 'POS2'},
      {id:'0004', name: 'STB2', side: 'STB', pos: 'POS2'},
      {id:'0005', name: 'PORT3', side: 'PRT', pos: 'POS3'},
      {id:'0006', name: 'STB3', side: 'STB', pos: 'POS3'}
    ]});
export const PositionsState =
  atom<string[]>({
    key: 'Positions',
    default: ['POS1', 'POS2', 'POS3']
  });

function SensorSettings() {
  const items = useRecoilValue(SensorParametersState);
  const setItems = useSetRecoilState(SensorParametersState);
  const position = useRecoilValue(PositionsState);
  const setPosition = useSetRecoilState(PositionsState);

  const replaceItem = (index: number, item?: SensorParameter) => {
    const tmp = [...items];
    if (item == undefined) {
      tmp.splice(index, 1);
    } else {
      tmp.splice(index, 1, item);
    }
    setItems(tmp);

    let pos : string[] = [];
    tmp.map(item => {
      if (!pos.includes(item.pos)) {
        pos = [...pos, item.pos];
      }
    })
    setPosition(pos);
  };
  const removeItem = (index: number) => { replaceItem(index); };

  const replaceItemMember = (index: number, item: SensorParameter, member: string, value: string) => {
    const tmp: SensorParameter = {} as SensorParameter;
    Object.assign(tmp, item);
    if (member == 'id') {
      tmp.id = value;
    } else if (member == 'name') {
      tmp.name = value;
    } else if (member == 'side') {
      tmp.side = value;
    } else if (member == 'pos') {
      tmp.pos = value;
    } else {
      tmp.name = value;
    }
    replaceItem(index, tmp);
  };
  const replaceItemId = (index: number, item: SensorParameter, value: string) => { replaceItemMember(index, item, 'id', value); };
  const replaceItemName = (index: number, item: SensorParameter, value: string) => { replaceItemMember(index, item, 'name', value); };
  const replaceItemSide = (index: number, item: SensorParameter, value: string) => { replaceItemMember(index, item, 'side', value); };
  const replaceItemPos = (index: number, item: SensorParameter, value: string) => { replaceItemMember(index, item, 'pos', value); };
  
  return (
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
      <legend>センサー名称設定</legend>
      <Grid container spacing={2}>
        <Grid container item>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>名称</TableCell>
                  <TableCell>サイド</TableCell>
                  <TableCell>船長方向位置</TableCell>
                  <TableCell>センサー種類</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, index) => (
                  <TableRow
                    key={item.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <TextField size="small" defaultValue={item.id} onBlur={e => replaceItemId(index, item, e.target.value)} />
                    </TableCell>
                    <TableCell>
                      <TextField size="small" defaultValue={item.name} onBlur={e => replaceItemName(index, item, e.target.value)} />
                    </TableCell>
                    <TableCell>
                      <FormControl size="small" fullWidth>
                        <Select defaultValue="PRT" value={item.side} onChange={e => replaceItemSide(index, item, e.target.value)}>
                          <MenuItem value="PRT">左舷</MenuItem>
                          <MenuItem value="STB">右舷</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <TextField size="small" defaultValue={item.pos} onBlur={e => replaceItemPos(index, item, e.target.value)} />
                    </TableCell>
                    <TableCell>
                      <FormControl size="small" fullWidth>
                        <Select value={0}>
                          <MenuItem value={0}>ひずみ計</MenuItem>
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <Button size="small" variant="contained" onClick={() => removeItem(index)}>削除</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid container item xs={1.5}>
          <Button variant="contained" onClick={() => setItems([...items, {} as SensorParameter])}>追加</Button>
        </Grid>
        <Grid container item xs={7.5} />
        <Grid container item xs={3}>
          <Button variant="contained">サーバーから取得</Button>
        </Grid>
      </Grid>
    </Box>
  );
}

function ParameterSettings() {
  const items = useRecoilValue(SensorParametersState);
  const positions = useRecoilValue(PositionsState);

  return (
    <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
      <legend>パラメータ</legend>
      <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
        <legend>センサー設定</legend>
        <Grid container spacing={2}>
          <Grid container item xs={3}>
            <FormControl size="small" fullWidth>
              <InputLabel>ID/名称</InputLabel>
              <Select
                label="ID/名称"
              >
                {items.map(item => {
                  if ((item.id != '') && (item.name != '')) {
                    return (<MenuItem value={item.id + item.name}>{item.id} / {item.name}</MenuItem>);
                  }
                }).filter(x => x)}
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={9} />
          <Grid container item xs={2}>
            <TextField fullWidth label="ゲージ率" size="small" id="outlined-basic" variant="outlined" type="number" value={1} />
          </Grid>
          <Grid container item xs={2}>
            <TextField fullWidth label="ブリッジ電圧[V]" size="small" id="outlined-basic" variant="outlined" type="number" value={2.5} />
          </Grid>
          <Grid container item xs={2}>
            <TextField fullWidth label="弾性係数" size="small" id="outlined-basic" variant="outlined" type="number" value={1} />
          </Grid>
          <Grid container item xs={2}>
            <TextField fullWidth label="ゼロ点" size="small" id="outlined-basic" variant="outlined" type="number" value={1} />
          </Grid>
          <Grid container item xs={2}>
            <TextField fullWidth label="ゲイン" size="small" id="outlined-basic" variant="outlined" type="number" value={1} />
          </Grid>
          <Grid container item xs={3}>
            <FormControl size="small" fullWidth>
              <InputLabel>弾性振動成分カットオフ[Hz]</InputLabel>
              <Select
                label="弾性振動成分カットオフ[Hz]"
                defaultValue={0.3}
              >
                <MenuItem value={0.3}>0.3</MenuItem>
                <MenuItem value={0.4}>0.4</MenuItem>
                <MenuItem value={0.5}>0.5</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ flexGrow: 1, border: 1, borderRadius: 1 }} component={"fieldset"}>
        <legend>断面係数設定</legend>
        <Grid container spacing={2}>
          <Grid container item xs={3}>
            <FormControl size="small" fullWidth>
              <InputLabel>船長方向位置</InputLabel>
              <Select
                label="船長方向位置"
              >
                { positions.map(pos => (<MenuItem value={pos}>{pos}</MenuItem>)) }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item xs={3}>
            <TextField fullWidth label="断面係数" size="small" id="outlined-basic" variant="outlined" type="number" value={1} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

function Buttons() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid container item xs={1.9}>
          <Button variant="contained">インポート</Button>
        </Grid>
        <Grid container item xs={2.1}>
          <Button variant="contained">エクスポート</Button>
        </Grid>
        <Grid container item xs={6} />
        <Grid container item xs={2}>
          <Button variant="contained">適用</Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default function ParamSettings() {
  return (
    <Box width={'70%'}>
      <Grid container spacing={2}>
        <Grid container item>
          <SensorSettings />
        </Grid>
        <Grid container item>
          <ParameterSettings />
        </Grid>
        <Grid container item>
          <Buttons />
        </Grid>
      </Grid>
    </Box>
  );
}
